var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStaininline = function SvgStaininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1023,
    height: 849,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#stain_inline_svg__a)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#stain_inline_svg__b)",
    d: "M329.299 172.845c233.039-89.455 468.575-132.964 557.99 99.969 89.414 232.932 4.142 366.789-228.897 456.244-233.039 89.455-147.876-158.081-451.318-123.181C17.339 573.82 96.26 262.301 329.299 172.845Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stain_inline_svg__b",
    x1: 399.389,
    x2: 788.483,
    y1: 769.258,
    y2: 177.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#255DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#00A98F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#255DDE"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stain_inline_svg__a",
    width: 1021.22,
    height: 847.686,
    x: 0.858,
    y: 0.987,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_699_1855",
    stdDeviation: 50
  })))));
};
export default SvgStaininline;